import React, { useState, useEffect } from 'react'; // Added useEffect
import axios from 'axios';
import './Razorpay.css';

const BACKEND_URL = process.env.API_BASE_URL ||'https://api.hitkarihospital.com:5005';

const RAZORPAY_KEY_ID = 'rzp_test_gGH2tgOZcCZuDz'; // Your test key ID

function App() {
  const [amount, setAmount] = useState(100);
  const [loading, setLoading] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [paymentDetails, setPaymentDetails] = useState(null);
  const [currentOrder, setCurrentOrder] = useState(null); // To store order details for logging failures

  // Function to load Razorpay script dynamically (optional but good practice)
  const loadRazorpayScript = (src) => {
    return new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = src;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  };

  useEffect(() => {
    // Ensure script is loaded once when component mounts
    // Or you can keep it in public/index.html directly
    const loadScript = async () => {
        const res = await loadRazorpayScript('https://checkout.razorpay.com/v1/checkout.js');
        if (!res) {
            alert('Razorpay SDK failed to load. Are you online?');
        }
    }
    // loadScript(); // Uncomment if you want to load script dynamically
    // If script is in index.html, this useEffect isn't strictly needed for loading,
    // but good for other one-time setups.
  }, []);


  const logPaymentAttemptToServer = async (data) => {
    try {
      await axios.post(`${BACKEND_URL}/api/log-payment-attempt`, data);
      console.log('Payment attempt logged to server:', data.status);
    } catch (error) {
      console.error('Failed to log payment attempt to server:', error);
      // Handle logging failure if necessary, but don't block user flow
    }
  };

  const handlePayment = async () => {
    if (typeof window.Razorpay === 'undefined') {
        alert('Razorpay SDK not loaded. Please check your internet connection or refresh the page.');
        setLoading(false);
        return;
    }

    setLoading(true);
    setPaymentStatus(null);
    setPaymentDetails(null);
    setCurrentOrder(null); // Reset current order

    try {
      // 1. Create Order
      const orderResponse = await axios.post(`${BACKEND_URL}/api/create-order`, {
        amount: amount,
        currency: 'INR',
        // receipt: `user_rcptid_${Date.now()}` // You can pass receipt and notes
      });

      const { success, order } = orderResponse.data;

      if (!success || !order) {
        setPaymentStatus('error');
        setPaymentDetails({ message: orderResponse.data.message || 'Order creation failed.' });
        logPaymentAttemptToServer({ // Log this as a creation failure if desired
            // orderId might not exist here if creation itself failed badly
            status: 'creation_failed',
            amount: Number(amount) * 100,
            currency: 'INR',
            errorDescription: orderResponse.data.message || 'Order creation failed at client request phase.'
        });
        setLoading(false);
        return;
      }

      setCurrentOrder(order); // Store the created order details
      console.log('Order created:', order);

      // 2. Open Razorpay Checkout
      const options = {
        key: RAZORPAY_KEY_ID,
        amount: order.amount, // Amount from the order object (in paisa)
        currency: order.currency,
        name: "My Awesome Corp",
        description: "Test Transaction",
        image: "https://example.com/your_logo.jpg",
        order_id: order.id,
        handler: async function (response) {
          setLoading(true); // Keep loading while verifying
          try {
            const verifyResponse = await axios.post(`${BACKEND_URL}/api/verify-payment`, {
              razorpay_order_id: response.razorpay_order_id,
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_signature: response.razorpay_signature,
              // Optionally pass amount and currency if backend doesn't re-fetch order
              // amount: order.amount,
              // currency: order.currency,
            });

            if (verifyResponse.data.success) {
              setPaymentStatus('success');
              setPaymentDetails({
                message: 'Payment Successful!',
                orderId: response.razorpay_order_id,
                paymentId: response.razorpay_payment_id,
              });
            } else {
              setPaymentStatus('error');
              setPaymentDetails({
                message: verifyResponse.data.message || 'Payment verification failed.',
                orderId: response.razorpay_order_id,
              });
              // Log verification failure (already handled by backend if signature mismatch)
              // but if server call itself failed, you might log here
            }
          } catch (verifyError) {
            setPaymentStatus('error');
            setPaymentDetails({ message: 'Error verifying payment. Please contact support.' });
            // Log this client-side verification error if the call to /api/verify-payment fails
            logPaymentAttemptToServer({
                orderId: response.razorpay_order_id,
                paymentId: response.razorpay_payment_id, // Signature is available here
                status: 'verification_failed_client_error',
                amount: order.amount,
                currency: order.currency,
                receipt: order.receipt,
                notes: order.notes,
                errorDescription: verifyError.message,
            });
          }
          setLoading(false);
        },
        prefill: {
          name: "Payer Name",
          email: "payer.email@example.com",
          contact: "9000090000",
        },
        notes: order.notes, // Pass notes from the created order
        theme: {
          color: "#3399cc",
        },
        modal: {
          ondismiss: function () {
            console.log('Checkout form closed by user.');
            if (currentOrder && currentOrder.id) { // Check if order was created
              setPaymentStatus('info');
              setPaymentDetails({ message: 'Payment was cancelled or modal closed by user.' });
              logPaymentAttemptToServer({
                orderId: currentOrder.id, // Use stored order ID
                amount: currentOrder.amount,
                currency: currentOrder.currency,
                receipt: currentOrder.receipt,
                notes: currentOrder.notes,
                status: 'cancelled_by_user',
                errorDescription: 'User closed the payment modal.',
              });
            } else {
                console.log('Modal closed, but no order was created yet or an error occurred before order creation.')
            }
            setLoading(false);
          },
        },
      };

      const rzp = new window.Razorpay(options);
      rzp.on('payment.failed', function (response) {
        console.error('Payment Failed on Razorpay side:', response.error);
        setPaymentStatus('error');
        setPaymentDetails({
          message: `Payment Failed: ${response.error.description}`,
          code: response.error.code,
          orderId: response.error.metadata.order_id,
          paymentId: response.error.metadata.payment_id, // May or may not be present
        });

        // Log detailed failure information to your backend
        logPaymentAttemptToServer({
            orderId: response.error.metadata.order_id,
            paymentId: response.error.metadata.payment_id,
            amount: currentOrder ? currentOrder.amount : (Number(amount) * 100), // Fallback if currentOrder not set
            currency: currentOrder ? currentOrder.currency : 'INR',
            receipt: currentOrder ? currentOrder.receipt : undefined,
            status: 'failed',
            errorCode: response.error.code,
            errorDescription: response.error.description,
            errorSource: response.error.source,
            errorStep: response.error.step,
            errorReason: response.error.reason,
            method: response.error.method, // e.g., 'card', 'upi'
            notes: response.error.notes, // Or currentOrder.notes
        });
        setLoading(false);
      });

      rzp.open();
      // setLoading(false); // Important: setLoading(false) should be in handlers, not here.
      // rzp.open() is asynchronous.
    } catch (error) {
      console.error('Error during payment initiation:', error);
      setPaymentStatus('error');
      setPaymentDetails({ message: 'An unexpected error occurred before payment could start.' });
       // Log this generic client-side error attempt
       logPaymentAttemptToServer({
        orderId: currentOrder ? currentOrder.id : 'UNKNOWN_ORDER_ID',
        amount: currentOrder ? currentOrder.amount : (Number(amount) * 100),
        currency: currentOrder ? currentOrder.currency : 'INR',
        status: 'client_setup_error',
        errorDescription: error.message,
        errorReason: error.toString(),
       });
      setLoading(false);
    }
  };

  return (
    <div className="App">
      <header className="App-header">
        <h1>Razorpay Payment Gateway with DB Logging</h1>
      </header>
      <div className="payment-form">
        <input
          type="number"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          placeholder="Enter Amount (INR)"
          min="1"
        />
        <button onClick={handlePayment} disabled={loading} className="pay-button">
          {loading ? 'Processing...' : `Pay ₹${amount}`}
        </button>
      </div>

      {paymentStatus && (
        <div className={`status-message ${paymentStatus}`}>
          <h3>Payment {paymentStatus.charAt(0).toUpperCase() + paymentStatus.slice(1)}</h3>
          <p>{paymentDetails?.message}</p>
          {paymentDetails?.orderId && <p>Order ID: {paymentDetails.orderId}</p>}
          {paymentDetails?.paymentId && <p>Payment ID: {paymentDetails.paymentId}</p>}
          {paymentDetails?.code && <p>Error Code: {paymentDetails.code}</p>}
        </div>
      )}
    </div>
  );
}

export default App;